
export type TSystemEmailsTable = {
    loading?: boolean,
    reloadTable: () => void
}

export enum ESystemEmailType {
    accountConfirm = "account_confirm",
    userConfirm = "user_confirm",
    senderConfirm = "sender_confirm",
    passwordReset = "password_reset",
    contactDOptIn = "contact_double_opt_in",
}
